// extracted by mini-css-extract-plugin
export var section = "CommitmentsSection-module--section--a1094";